export default class DeviceCacheManager {
    constructor(api) {
        this.api = api;
    }

    getDeviceCache = () => this.api.getDeviceCache();
    setDeviceCache = (data) => this.api.setDeviceCache(data);
}
